// src/pages/PrivacyPage.tsx
// Публичная страница «Согласие на обработку персональных данных»:
// полный текст согласия и отмеченный чекбокс согласия.
import React, { useState } from 'react';
import styled from 'styled-components';
import Footer from '../components/common/Footer';
import { useLang } from '../context/LangContext';

const Page = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.background};
`;

const Main = styled.main`
  flex: 1;
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  padding: 32px 24px;
`;

const Section = styled.section`
  background: ${({ theme }) => theme.colors.cardBackground};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  padding: 20px 24px;
  margin-bottom: 16px;
  box-shadow: ${({ theme }) => theme.shadows.sm};
`;

const Title = styled.h1`
  color: ${({ theme }) => theme.colors.text};
  font-size: 1.6rem;
  margin: 0 0 16px;
`;

const P = styled.p`
  color: ${({ theme }) => theme.colors.text};
  line-height: 1.5;
  margin: 0 0 12px;
  text-align: justify;
`;

const ConsentRow = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 14px 16px;
  background: ${({ theme }) => theme.colors.background};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  cursor: pointer;
  color: ${({ theme }) => theme.colors.text};
  font-size: 0.95rem;
  line-height: 1.45;
`;

const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  margin-top: 3px;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  accent-color: ${({ theme }) => theme.colors.primary};
`;

const PrivacyPage: React.FC = () => {
  const { t } = useLang();
  const [checked, setChecked] = useState(true);

  return (
    <Page>
      <Main>
        <Title>{t('privacyTitle')}</Title>

        <Section>
          <P>{t('privacyP1')}</P>
          <P>{t('privacyP2')}</P>
          <P>{t('privacyP3')}</P>
          <P>{t('privacyP4')}</P>
          <P>{t('privacyP5')}</P>
          <P style={{ marginBottom: 0 }}>{t('privacyP6')}</P>
        </Section>

        <Section>
          <ConsentRow>
            <Checkbox
              checked={checked}
              onChange={(e) => setChecked(e.target.checked)}
            />
            <span>{t('privacyConsentLabel')}</span>
          </ConsentRow>
        </Section>
      </Main>
      <Footer />
    </Page>
  );
};

export default PrivacyPage;